import React from 'react';


interface Props {
    disable: boolean,
    OKHandler: (e:any) => void
    cancelHandler: () => void,
    className?: string
}

const ApplyButtons : React.FC<Props> = ({disable, OKHandler, cancelHandler, className}) => {
    return (
        <div className={'applyButtons'}>
            <div className='applyButtons__cancel'
                 onClick={() => cancelHandler()}
                 draggable={false}
            >
                <span className={className ? className: ''}> &#x2717; </span>
            </div>

            <div className={!disable ? 'applyButtons__OK' : 'applyButtons__OK disable'}
                 onClick={(e) => { !disable && OKHandler(e) }}
                 draggable={false}
            >
                <span className={className ? className: ''}> &#10004; </span>
            </div>
        </div>
    )
};

export default ApplyButtons